import {SliderInterface} from "@share/presentation/interfaces/SliderInterface";
import {SliderParams} from "@share/presentation/types/SliderParams";
import {MediaSliderState} from "@share/presentation/types/MediaSliderState";
import {GoToParams} from "@share/presentation/types/GoToParams";

export abstract class SliderBase implements SliderInterface {
    isClickable = false;
    needToEmitMoved = false;
    isFluent = false;
    params: SliderParams = {
        state: null,
        slideSize: 0,
        slidesLength: 0,
        totalSize: 0
    };

    protected constructor(isClickable = false, needToEmitMoved = false, isFluent = false) {
        this.isClickable = isClickable;
        this.needToEmitMoved = needToEmitMoved;
        this.isFluent = isFluent;
    }

    get state() {
        return this.params.state as MediaSliderState;
    }

    abstract dragEnd(currentOffset: number): GoToParams;

    setParams(params: SliderParams): void {
        this.params = {...this.params, ...params};
    }

    abstract shiftSlide(direction: 1 | -1, currentOffset: number): GoToParams;

    isFirst(): boolean {
        return this.state?.index == 0;
    }

    isLast(): boolean {
        return this.state?.index == this.params.slidesLength - 1;
    }

}
